import React, { Component, Fragment } from "react";
import DragContainerUI from "../../ddTxtImg/ui/DragContainerUI";
import ClassificationContainerUI from "./ClassificationContainerUI";
class ClassificationActivityUI extends Component {
  render() {
    let { activity, quizViewer } = this.props;

    return (
      <Fragment>
        <DragContainerUI activity={activity} quizViewer={quizViewer} />
        <ClassificationContainerUI  activity={activity} quizViewer={quizViewer}/>
      </Fragment>
    );
  }
}
export default ClassificationActivityUI;
